import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./sidebar.css";
import logo from "./assets/cc.jpg";
import defaultProfile from "./assets/bull.jpg";
import { backend_url } from "./constants/backend";

export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [userData, setUserData] = useState(null);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setEmail(sessionStorage.getItem("userEmail") || "");
    setRole(sessionStorage.getItem("userRole") || "");
  }, []);

  // 🔥 FETCH USER INFO WHEN SIDEBAR OPENS
  useEffect(() => {
    if (!open || !email) return;

    const fetchSidebarData = async () => {
      try {
        const resp = await fetch(`${backend_url}/sidebar-email/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email, role: role }),
        });

        if (!resp.ok) {
          console.error("❌ Sidebar API Error:", resp.status);
          return;
        }

        const data = await resp.json();
        setUserData(data);
      } catch (error) {
        console.error("❌ Error fetching sidebar data:", error);
      }
    };

    fetchSidebarData();
  }, [open, email, role]);

  // Sync email + role when changed globally
  useEffect(() => {
    const updateEmail = () =>
      setEmail(sessionStorage.getItem("userEmail") || "");
    const updateRole = () =>
      setRole(sessionStorage.getItem("userRole") || "");

    window.addEventListener("userEmailChanged", updateEmail);
    window.addEventListener("userRoleChanged", updateRole);

    return () => {
      window.removeEventListener("userEmailChanged", updateEmail);
      window.removeEventListener("userRoleChanged", updateRole);
    };
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("userEmail");
    sessionStorage.removeItem("userRole");

    setEmail("");
    setRole("");
    setUserData(null);

    window.dispatchEvent(new Event("userEmailChanged"));
    window.dispatchEvent(new Event("userRoleChanged"));

    setOpen(false);
    navigate("/login");
  };

  const profileSrc =
    userData?.profile_photo && userData.profile_photo !== ""
      ? userData.profile_photo
      : defaultProfile;

  return (
    <>
      {/* HAMBURGER ICON */}
      <div className="hamburger-box" onClick={() => setOpen(!open)}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>

      {/* OVERLAY */}
      {open && <div className="overlay" onClick={() => setOpen(false)} />}

      <div className={`sidebar ${open ? "show" : ""}`}>
        {/* USER INFO */}
        <div
          style={{
            padding: "12px 16px",
            borderBottom: "1px solid rgba(255,255,255,0.04)",
          }}
        >
          {email ? (
            <>
              {/* PROFILE PIC */}
              <div style={{ textAlign: "left", marginBottom: 10 }}>
                <img
                  src={profileSrc}
                  alt="Profile"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid #4fc3f7",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsProfileOpen(true)}
                  onError={(e) => (e.target.src = defaultProfile)}
                />
              </div>

              {/* SIGNED IN */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingRight: "8px",
                }}
              >
                <div style={{ fontSize: 12, color: "#9aa6bf" }}>
                  Signed in as
                </div>

                {userData && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0,
                      fontSize: 16,
                      fontWeight: 700,
                      color: "#facc15",
                      whiteSpace: "nowrap",
                      marginRight: "5px",
                    }}
                  >
                    <span style={{ fontSize: 18 }}>🪙</span>
                    <span>{userData.points || 0}</span>
                  </div>
                )}
              </div>

              {/* EMAIL */}
              <div
                style={{
                  marginTop: 6,
                  fontWeight: 700,
                  color: "#4fc3f7",
                  fontSize: 14,
                  wordBreak: "break-word",
                }}
              >
                {email}
              </div>

              <button
                onClick={handleLogout}
                style={{
                  marginTop: 10,
                  padding: "8px 10px",
                  borderRadius: 8,
                  background: "#ef4444",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                  width: "100%",
                }}
              >
                Logout
              </button>
            </>
          ) : (
            <div style={{ color: "#9aa6bf", fontSize: 14 }}>
              Not signed in
            </div>
          )}
        </div>

        {/* MENU */}
        <nav
          className="menu"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            padding: 16,
          }}
        >
          {!email && (
            <>
              <Link to="/welcome" onClick={() => setOpen(false)}>
                Register
              </Link>
              <Link to="/" onClick={() => setOpen(false)}>
                Login
              </Link>
            </>
          )}

          {(role === "Admin" ||
            role === "Co_ordinator" ||
            role === "User") && (
            <Link
              to="/profile"
              state={{ email, role }}
              onClick={() => setOpen(false)}
            >
              Profile
            </Link>
          )}

          {(role === "Admin" ||
            role === "Co_ordinator" ||
            role === "User") && (
            <Link
              to="/firstpage"
              state={{ email, role }}
              onClick={() => setOpen(false)}
            >
              Feedback
            </Link>
          )}

          {(role === "Admin" || role === "Co_ordinator") && (
            <Link
              to="/Invition"
              state={{ email, role }}
              onClick={() => setOpen(false)}
            >
              Invitation
            </Link>
          )}

          {(role === "Admin" || role === "Co_ordinator") && (
            <Link
              to="/idcard"
              state={{ email, role }}
              onClick={() => setOpen(false)}
            >
              Id Card Scan
            </Link>
          )}

          {(role === "Admin" ||
            role === "Co_ordinator" ||
            role === "User") && (
            <Link
              to="/point"
              state={{ email, role }}
              onClick={() => setOpen(false)}
            >
              Scan Points
            </Link>
          )}

          {(role === "Admin" ||
            role === "Co_ordinator" ||
            role === "User") && (
            <Link
              to="/coupon"
              state={{ email, role }}
              onClick={() => setOpen(false)}
            >
              Gift Coupon
            </Link>
          )}
        </nav>

        {/* FOOTER LOGO */}
        {open && (
          <div
            style={{
              position: "absolute",
              bottom: "35px",
              left: 0,
              width: "100%",
              padding: "10px",
              textAlign: "center",
            }}
          >
            <img
              src={logo}
              alt="logo"
              style={{
                width: "95%",
                borderRadius: "12px",
                opacity: 0.95,
              }}
            />
          </div>
        )}
      </div>

      {/* FULL PROFILE PIC MODAL */}
      {isProfileOpen && (
        <div
          className="profile-modal-overlay"
          onClick={() => setIsProfileOpen(false)}
        >
          <div
            className="profile-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="profile-close-btn"
              onClick={() => setIsProfileOpen(false)}
            >
              ✕
            </button>

            <img
              src={profileSrc}
              alt="Full Profile"
              className="profile-modal-img"
              onError={(e) => (e.target.src = defaultProfile)}
            />
          </div>
        </div>
      )}
    </>
  );
}
